import type { IColumn } from 'shared/ui/TableNew'
import type { RowConversationsComparison } from 'entities/Analytics/model/Table/RowConversationsComparison'
import type { SearchTypesEnum } from 'widgets/SearchDropdown'
import { getBreakdownColumnName } from 'pages/analytics/lib'
import { AnalyticMetricCell, BreakdownEntityCell } from 'pages/analytics/ui'

export const getColumns = (
  filterType: SearchTypesEnum | null
): IColumn<RowConversationsComparison>[] => [
  {
    field: 'name',
    name: getBreakdownColumnName(filterType),
    fullName: getBreakdownColumnName(filterType),
    isDisabledChangeVisible: true,
    renderRowCell: (row) => {
      const { name, breakdownEntity } = row.fields

      return (
        <BreakdownEntityCell
          filterType={filterType}
          breakdownEntity={breakdownEntity}
          fallbackName={name}
        />
      )
    },
  },
  {
    field: 'total',
    name: 'Total conversations',
    renderRowCell: (row) => {
      const { total } = row.fields

      return <AnalyticMetricCell value={total} />
    },
  },
  {
    field: 'open',
    name: 'Open conversations',
    renderRowCell: (row) => {
      const { open } = row.fields

      return <AnalyticMetricCell value={open} />
    },
  },
  {
    field: 'closed',
    name: 'Closed conversations',
    renderRowCell: (row) => {
      const { closed } = row.fields

      return <AnalyticMetricCell value={closed} />
    },
  },
]
